import { render, staticRenderFns } from "./Hotdeal.page.vue?vue&type=template&id=35bba4c8&"
import script from "./Hotdeal.page.vue?vue&type=script&lang=js&"
export * from "./Hotdeal.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports